import { render } from "./AsideMenuItem.vue?vue&type=template&id=252e9946&scoped=true&ts=true"
import script from "./AsideMenuItem.vue?vue&type=script&lang=ts"
export * from "./AsideMenuItem.vue?vue&type=script&lang=ts"

import "./AsideMenuItem.vue?vue&type=style&index=0&id=252e9946&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-252e9946"]])

export default __exports__